// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".result[data-v-242f1562]{padding-top:80px;text-align:center;min-height:calc(100vh - 370px)}iframe[data-v-242f1562]{width:100%;height:calc(100vh - 58px)}.downloadBtn[data-v-242f1562]{position:fixed;top:16px;right:50px}[data-v-242f1562] .el-dialog__body{padding:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
